import { render, staticRenderFns } from "./Ombudsman.vue?vue&type=template&id=4e3c4e1a&"
import script from "./Ombudsman.vue?vue&type=script&lang=js&"
export * from "./Ombudsman.vue?vue&type=script&lang=js&"
import style0 from "./Ombudsman.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports